import ApiLogin from '@/api/apiLogin'
import Vue from 'vue'
import router from '../router'
import Session from "../models/session";

const state = {
  session: undefined,
  sportPlaceName:""
}

const actions = {
  login({ commit, state }, user) {
      ApiLogin.login(user.email, user.password,
      (session) => {
        Vue.config.session.start()
        Vue.config.session.set("data", session)
        commit("updateSession", session)

        localStorage.setItem("data-pitz", JSON.stringify(session))

        if(session.type == "pitz"){
          router.push("/users")
        }else if(session.type == "place_admin"){
          router.push("/tournaments")
        }else{
          router.push("/registrations-statistics")
        }
        //router.push("/")
      }, error => {
        console.log('Error', error)
      })
  },
  checkSession({ commit, state }) {
    if(Vue.config.session.exists() || localStorage.getItem("data-pitz")) {
      let session = Vue.config.session.get("data") || JSON.parse(localStorage.getItem("data-pitz"))
      Vue.config.session.set("data", session)
      Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${session.token}`
      commit("updateSession", session)
    }else{
      commit("updateSession", undefined)
      router.push("/login")
    }

  },
  logOut({commit, state}) {
    Vue.config.session.destroy()
    localStorage.removeItem("data-pitz")
    commit("updateSession", undefined)
    router.push("/login")
  }

}

const mutations = {
  updateSession(state, session) {
    state.session = session
  }
}

const getters = {
  currentSession(state) {
    return state.session
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/session.js